
// ensure the main object is defined
if (typeof(so) === 'undefined') {
    var so = {
        app: {
            featherlight: {}
        }
    };
}

// main code
so.app.featherlight = {
    init: function () {
        this.featherlightInit();
    },
    featherlightInit: function() {
        // General lightbox
        $('.featherlight').featherlight({
            closeIcon: ''
        });

        // // Lightbox with gallery
        // $('a.featherlight-gallery').featherlightGallery({
        //     previousIcon: '',     /* Code that is used as previous icon */
        //     nextIcon: '',         /* Code that is used as next icon */
        //     closeIcon: '',
        //     galleryFadeIn: 100,          /* fadeIn speed when slide is loaded */
        //     galleryFadeOut: 300          /* fadeOut speed before slide is loaded */
        // });
    }
};

$(document).ready(function () {
    so.app.featherlight.init();
});
